<template>
  <div
    :class="[
      isHero
        ? 'mt-1.5 flex flex-wrap justify-center gap-1 max-w-[210px] sm:max-w-[230px] mx-auto'
        : 'mt-4 flex flex-wrap justify-center gap-2 max-w-lg mx-auto'
    ]"
  >
    <button
      v-for="(cand, idx) in cands"
      :key="idx"
      type="button"
      :disabled="cand.used"
      @click="$emit('select-cand', idx)"
      class="font-bold text-clay select-none cursor-pointer flex items-center justify-center transition-all hover:-translate-y-0.5 active:translate-y-0.5 active:shadow-none disabled:invisible"
      :class="[
        isHero
          ? 'h-7 w-7 sm:h-7.5 sm:w-7.5 rounded-md border border-border/80 bg-white text-sm sm:text-base shadow-[0_1.5px_0_#2f3f86]'
          : 'h-11 w-11 sm:h-13 sm:w-13 rounded-xl border-2 border-border bg-white text-xl sm:text-2xl shadow-[0_3px_0_#2f3f86]',
        { 'opacity-0 pointer-events-none': cand.used }
      ]"
    >
      {{ cand.ch }}
    </button>
  </div>
</template>

<script setup lang="ts">
import type { Cand } from '../lib/types'

withDefaults(
  defineProps<{
    cands: Cand[]
    isHero?: boolean
  }>(),
  {
    isHero: false,
  }
)

defineEmits<{
  (e: 'select-cand', idx: number): void
}>()
</script>

